import { batch } from 'react-redux';

import { getAgencies } from '../../api/agencies';
import { getRealtors } from '../../api/realtors';
import type { TThunkAction } from '../../types/redux';
import { getQueryString } from '../../utils/getQueryString';
import { setAgenciesItems, setAgenciesLoading, setRealtorItems, setRealtorsLoading } from '../listing';
import { trackPageView } from '../../utils/analytics/trackPageView';
import { setSearchTextRealtors, setSearchTextAgencies } from './actions';

export function getListingRealtors<P>(action: Function, param: P): TThunkAction<Promise<void>> {
  return (dispatch, getState, context) => {
    batch(() => {
      dispatch(action(param));
      dispatch(setSearchTextRealtors(undefined));
      dispatch(setRealtorsLoading(true));
    });

    const state = getState();
    const {
      tab,
      realtors: {
        filters,
        listing: { page },
      },
      geo: { locationsMap },
    } = state;
    // oxlint-disable-next-line typescript/no-non-null-assertion
    const regionId = locationsMap[tab]!.id;
    const params = { ...filters, regionId, page };

    // TODO: Вторую пустую строку заменить на реальный document title CD-100235
    window.history.pushState('', '', getQueryString(tab, page, params));

    trackPageView(state);

    return getRealtors(context, params).then(response => {
      dispatch(
        setRealtorItems({
          ...response,
          page,
        }),
      );
    });
  };
}

export function getListingAgencies<P>(action: Function, param: P): TThunkAction<Promise<void>> {
  return (dispatch, getState, context) => {
    batch(() => {
      dispatch(action(param));
      dispatch(setSearchTextAgencies(undefined));
      dispatch(setAgenciesLoading(true));
    });

    const state = getState();
    const {
      tab,
      agencies: {
        filters,
        listing: { page },
      },
      geo: { locationsMap },
    } = state;
    // oxlint-disable-next-line typescript/no-non-null-assertion
    const regionId = locationsMap[tab]!.id;
    const params = { ...filters, regionId, page };

    // TODO: Вторую пустую строку заменить на реальный document title CD-100235
    window.history.pushState('', '', getQueryString(tab, page, params));

    trackPageView(state);

    return getAgencies(context, params).then(response => {
      dispatch(
        setAgenciesItems({
          ...response,
          page,
        }),
      );
    });
  };
}
